module.exports = __webpack_public_path__ + "static/media/kneenetic-1.6e3ed401.jpg";